module.exports = __webpack_public_path__ + "media/images/cc_logos/mastercard-9277f369136a49a3ef6e16820eeaad9a.png";